module.exports = __webpack_public_path__ + "static/media/HCMM927.46323498.jpg";